import { render } from "./ProjectExpenseBar.vue?vue&type=template&id=ad54d5de"
import script from "./ProjectExpenseBar.vue?vue&type=script&lang=js"
export * from "./ProjectExpenseBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__